import {
  post,
  get,
  deletee,
  put,
  convertToForm,
  content_types
} from 'services';
import { AxiosPromise } from 'axios';
import { IUsersRegion, IgetUserApiData } from 'types/index';

export const getUserRegions = (
  getUserApiData: IgetUserApiData
): AxiosPromise<{ data: { rows: IUsersRegion[]; count: number } }> => {
  return get({
    subUrl: '/user-regions',
    params: getUserApiData
  });
};

export type IAddUserRegionsApiData = {
  name: string;
  code: string;
  is_shipping_available: boolean;
};
export const addUserRegions = (
  addUserRegionApiData: IAddUserRegionsApiData
) => {
  return post({
    subUrl: '/user-regions/add',
    data: convertToForm(addUserRegionApiData),
    headers: {
      ...content_types.multipart
    }
  });
};

export type IEditUserRegionsApiData = {
  id: string;
  name: string;
  code: string;
  is_shipping_available: boolean;
};
export const editUserRegion = (
  editUserRegionsApiData: IEditUserRegionsApiData
): AxiosPromise<IUsersRegion[]> => {
  return put({
    subUrl: '/user-regions',
    data: editUserRegionsApiData
  });
};

export type IdeleteRegion = {
  id: string;
  name: string;
  code: string;
};
export const deleteRegion = (data: string): AxiosPromise<any> => {
  return deletee({
    subUrl: '/user-regions',
    params: { id: data }
  });
};
